import { render, staticRenderFns } from "./RestoreModal.vue?vue&type=template&id=48c47fee&scoped=true&"
import script from "./RestoreModal.vue?vue&type=script&lang=js&"
export * from "./RestoreModal.vue?vue&type=script&lang=js&"
import style0 from "./RestoreModal.vue?vue&type=style&index=0&id=48c47fee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c47fee",
  null
  
)

export default component.exports